/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import GeneVariantPresentModel from '../../models/GeneVariantPresentModel';
import { createGeneVariantResult } from '../../models/HealthEntryCompose/geneVariantResult';
import MedliTerm from '../components/MedliTerm';
import { useLists } from '../hooks/useLists';
import { useActiveUser } from '../hooks/useUser';

interface Props {
  className?: string;
  style?: object;
  geneVariantResult: any;
}
const GeneVariantResultText: React.FC<Props> = (props) => {
  const { geneVariantResult, className, style } = props;

  const [{ geneVariantPresentLookup }] = useLists();
  const [{ preferredLanguageCode }] = useActiveUser();

  const geneVariantResultInstance = createGeneVariantResult(geneVariantResult);

  const classificationId = geneVariantResultInstance.getClassificationId();
  const variantPresentId = geneVariantResultInstance.getVariantPresentId();
  const geneticVariant = new GeneVariantPresentModel(geneVariantPresentLookup[variantPresentId]);

  if (!geneVariantResult || !geneVariantResultInstance.hasGeneticResult()) {
    return <FormattedMessage id="ui-data.value.not-specified.text" />;
  }

  return (
    <span className={className} style={style}>
      {
        classificationId ? (
          <MedliTerm medliTerm={geneVariantResult.gene_variant_classification} languageCode={preferredLanguageCode} />
        ) : (
          <FormattedMessage id={geneticVariant.textKey()} />
        )
      }
    </span>
  );
};

export default GeneVariantResultText;
